import { runtimeConfig } from '../lib/runtimeConfig';

export function useRuntimeConfig() {
    return runtimeConfig;
}
